import withStyles from '@mui/styles/withStyles';
import Switch from '@mui/material/Switch';

const CustomSwitch = withStyles(theme => ({
  root: {
    width: 40,
    height: 22,
    padding: 0,
    display: 'flex',
    '& > .Mui-disabled.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      opacity: '0.4',
    },
  },
  switchBase: {
    padding: 2,
    '&$checked': {
      transform: 'translateX(18px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: '#0F8461',
        borderColor: '#0F8461',
      },
    },
  },
  thumb: {
    width: 18,
    height: 18,
    boxShadow: 'none',
    backgroundColor: theme.palette.common.white,
  },
  track: {
    borderRadius: 22 / 2,
    opacity: 1,
    backgroundColor: '#D6D4E4',
  },
  checked: {
    '& > .MuiSwitch-thumb': {
      backgroundColor: theme.palette.common.white,
    },
  },

}))(Switch);

export default CustomSwitch;
